import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service, ModuleId } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getAllUsers(isActive: boolean = false, showLoader = true): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/lookup/users?moduleId=${ModuleId.FileManager}`, {
      showLoader,
      showMessage: false
    });
  }
}
